import { styled, Box, InverseCorner } from "@mode/components"
import { Block } from "./CoreCapabilitiesBlock.styles"
import Image from 'gatsby-plugin-sanity-image'

const Text = styled('div', {
  fontSize: '$p3',
  fontFamily: '$sans',
  color: '$g5',
  fontWeight: '500'
})

const Icon = ({ src }) => (
  <Box css={{ mb: '10px', width: '24px', height: '24px', position: 'relative' }}>
    <Image {...src} alt={src.alt} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
  </Box>
)

export const MobileGrid = ({
  eyebrow,
  heading,
  subheading,
  adHocTitle,
  adHocIcon,
  adHocLink,
  selfServeTitle,
  selfServeIcon,
  selfServeLink,
  dataVisualizationTitle,
  dataVisualizationIcon,
  dataVisualizationLink,
  customDataAppsTitle,
  customDataAppsIcon,
  customDataAppsLink,
  advancedAnalyticsTitle,
  advancedAnalyticsIcon,
  advancedAnalyticsLink,
  link
}) => {
  return (
    <Box css={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', px: '$xxs', pb: '$xs', pt: '$xxxs', width: '100%', '@md': { display: 'none' } }}>
      <Block
        as="a"
        href={`/${adHocLink?.slug.current}`}
        css={{ position: 'relative', width: '100%', height: '110px', borderRadius: '$4', borderBottomLeftRadius: 0 }}>
        <Block css={{ position: 'absolute', top: '100%', left: 0, width: 'calc(50% - 4px)', height: '75px', borderBottomLeftRadius: '$4', borderBottomRightRadius: '$4' }}>
          <Box>
            <Icon src={adHocIcon} />
            {adHocTitle}
            <InverseCorner position="topRight" fg="$g4" css={{ zIndex: '0' }} />
          </Box>
        </Block>
      </Block>
      <Box css={{ width: 'calc(50% - 4px)' }} />
      <Block
        as="a"
        href={`/${advancedAnalyticsLink.slug.current}`}
        css={{ position: 'relative', zIndex: 2, width: 'calc(50% - 4px)', height: '135px', mt: '$base', borderRadius: '$4' }}>
        <Box>
          <Icon src={advancedAnalyticsIcon} />
          {advancedAnalyticsTitle}
        </Box>
      </Block>
      <Block
        as="a"
        href={`/${selfServeLink?.slug.current}`}
        css={{ position: 'relative', width: 'calc(65% - 4px)', height: '135px', mt: '$base', borderRadius: '$4', borderTopLeftRadius: 0, marginTop: '$base', zIndex: 1 }}>
        <Block css={{ position: 'absolute', bottom: 'calc(100% - 8px)', left: 0, width: 'calc(80% - 7px)', height: '76px', mt: '$base', borderRadius: '$4', marginTop: '-60px', borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
          <InverseCorner position="bottomRight" fg="$g4" css={{ zIndex: '0', bottom: '8px' }} />
        </Block>
        <Box>
          <Icon src={selfServeIcon} />
          {selfServeTitle}
        </Box>
      </Block>
      <Block
        as="a"
        href={`/${customDataAppsLink?.slug.current}`}
        css={{ width: 'calc(45% - 4px)', height: '105px', mt: '$base', borderRadius: '$4' }}>
        <Box>
          <Icon src={customDataAppsIcon} />
          {customDataAppsTitle}
        </Box>
      </Block>
      <Block
        as="a"
        href={`/${dataVisualizationLink?.slug.current}`}
        css={{ position: 'relative', width: 'calc(55% - 4px)', height: '105px', mt: '$base', borderRadius: '$4', borderTopRightRadius: 0 }}>
        <Block css={{ position: 'absolute', bottom: '100%', right: 0, width: 'calc(65% - 4px)', height: '143px', mt: '$base', borderTopLeftRadius: '$4', borderTopRightRadius: '$4' }}>
          <InverseCorner position="bottomLeft" fg="$g4" css={{ zIndex: '0' }} />
        </Block>
        <Box css={{ maxWidth: '120px' }}>
          <Icon src={dataVisualizationIcon} />
          {dataVisualizationTitle}
        </Box>
      </Block>
    </Box >
  )
}